import { FC, useMemo, useState } from "react";
import { ExamListItem } from "../../../types/exam";
import styles from "./index.module.scss";
import LockIcon from "../../../icons/exam-lock";
import BookActiveIcon from "../../../icons/book-active";
import BookDisabledIcon from "../../../icons/book-disabled";
import cn from "classnames";
import { Modal } from "@quark/design";
import { QRCodeSVG } from "qrcode.react";
import { useNavigate } from "react-router-dom";

interface ExamCardProps {
  dataSource: ExamListItem;
}

const ExamCard: FC<ExamCardProps> = ({ dataSource }) => {
  const navigate = useNavigate();
  const { id, log, is_lock } = dataSource;
  const answerCount = useMemo(() => {
    const { right_num = 0, wrong_num = 0 } = log || {};
    return right_num + wrong_num;
  }, [log]);
  const [unlockVisible, setUnlockVisible] = useState(false);

  const onUnlock = () => {
    setUnlockVisible(true);
  };

  const gotoResultPage = () => {
    navigate(`/exam/${id}/${log?.id}`);
  };

  const gotoExamPage = () => {
    navigate(`/exam/${dataSource.id}`);
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.title}>{dataSource.title}</div>
            {dataSource.is_lock ? (
              <div className={cn(styles.button)} onClick={onUnlock}>
                <LockIcon />
                &nbsp; 解锁
              </div>
            ) : (
              <>
                {!!dataSource.log ? (
                  <>
                    {dataSource.log.status === "done" ? (
                      <div
                        className={cn(styles.button, styles.warning)}
                        onClick={gotoResultPage}
                      >
                        查看结果
                      </div>
                    ) : (
                      <div
                        className={cn(styles.button, styles.primary)}
                        onClick={gotoExamPage}
                      >
                        继续刷题
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    className={cn(styles.button, styles.secondary)}
                    onClick={gotoExamPage}
                  >
                    立即刷题
                  </div>
                )}
              </>
            )}
          </div>
          <div className={styles.footer}>
            {is_lock ? (
              <div className={styles.unlockTip}>题库暂未解锁</div>
            ) : (
              <div className={styles.info}>
                {!!log ? (
                  <>
                    已答: &nbsp;
                    <span
                      className={styles.infoValue}
                    >{`${answerCount}/${log?.quiz_num}`}</span>
                  </>
                ) : (
                  <span className={styles.infoValue}>已解锁</span>
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.book}>
          {is_lock ? <BookDisabledIcon /> : <BookActiveIcon />}
        </div>
      </div>

      <Modal
        title={<b>解锁题库</b>}
        visible={unlockVisible}
        onClose={() => setUnlockVisible(false)}
      >
        <div className={styles.modalContent}>
          <div className={styles.tips}>购买任意课程可解锁题库功能</div>
          <QRCodeSVG value="https://edu.py2fun.com/mobile?from=pc_exam" />
          <div>打开微信扫一扫</div>
        </div>
      </Modal>
    </>
  );
};

export default ExamCard;
